export default __webpack_public_path__ + "media/zurb/img/playground/design-stack-8ed867c2c417b0e868c029f986d53aa8.png";